const MARKS = [
  { top: "2%", size: "7vh", dur: 34, delay: -5, sway: 9, op: 0.12, dir: "normal", color: "#f5b335" },
  { top: "18%", size: "4vh", dur: 42, delay: -18, sway: 11, op: 0.09, dir: "reverse", color: "#ff4d9d" },
  { top: "34%", size: "8.5vh", dur: 30, delay: -9, sway: 8, op: 0.12, dir: "normal", color: "#c44df0" },
  { top: "52%", size: "3.5vh", dur: 38, delay: -22, sway: 10, op: 0.09, dir: "reverse", color: "#f5b335" },
  { top: "68%", size: "6vh", dur: 32, delay: -13, sway: 12, op: 0.12, dir: "normal", color: "#ff4d9d" },
  { top: "84%", size: "4.5vh", dur: 40, delay: -17, sway: 9, op: 0.1, dir: "reverse", color: "#c44df0" },
];

export function Watermark({ opacityBoost = 1 }) {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-0 overflow-hidden" data-testid="watermark">
      {MARKS.map((w, i) => (
        <div
          key={i}
          className="tk-drift absolute left-0"
          style={{
            top: w.top,
            fontSize: w.size,
            lineHeight: 1,
            opacity: w.op * opacityBoost,
            animationDuration: `${w.dur}s`,
            animationDelay: `${w.delay}s`,
            animationDirection: w.dir,
            fontFamily: "'Baloo 2', 'Bricolage Grotesque', system-ui, sans-serif",
          }}
        >
          <div className="tk-sway" style={{ animationDuration: `${w.sway}s` }}>
            <span className="font-extrabold" style={{ color: w.color, textShadow: `0 0 26px ${w.color}` }}>?</span>
          </div>
        </div>
      ))}
    </div>
  );
}
